module.exports = __webpack_public_path__ + "static/media/user-circle.c0b65b99.svg";